/** BullMQ queue / job names and payload types shared by web (producer) and worker (consumer). */
export const QUEUES = {
  photo: 'photo',
  export: 'export',
  maintenance: 'maintenance',
} as const;
export type QueueName = (typeof QUEUES)[keyof typeof QUEUES];

export const JOBS = {
  ingest: 'ingest',
  importGoogle: 'importGoogle',
  render: 'render',
  purge: 'purge',
} as const;
export type JobName = (typeof JOBS)[keyof typeof JOBS];

export type GoogleSource = 'google-photos' | 'google-drive';

export interface IngestJobData {
  photoId: string;
}
export interface ImportGoogleJobData {
  photoId: string;
  source: GoogleSource;
  item: { id: string; name: string; mime: string; baseUrl?: string };
  userId: string;
  /** short-lived Google access token obtained by the web app at enqueue time (fallback: account row) */
  accessToken?: string;
}
export interface RenderJobData {
  jobId: string;
}
export interface PurgeJobData {
  dryRun?: boolean;
}

export type JobDataMap = {
  ingest: IngestJobData;
  importGoogle: ImportGoogleJobData;
  render: RenderJobData;
  purge: PurgeJobData;
};

/** Repeatable purge schedule id + cron (03:00 daily). */
export const PURGE_SCHEDULER_ID = 'retention-purge-daily';
export const PURGE_CRON = '0 3 * * *';

/** Redis keys (plain ioredis, outside BullMQ). */
export const redisKeys = {
  /** JSON RenderManifest written by the worker before Chromium opens /render/{jobId}/... */
  renderManifest: (jobId: string) => `render:${jobId}`,
  /** set to "1" to ask a running render to stop between targets */
  exportCancel: (jobId: string) => `export:cancel:${jobId}`,
  /** contributor upload counter for the current hour bucket */
  contributeRate: (token: string, hourBucket: number) => `rl:contrib:${token}:${hourBucket}`,
} as const;

export interface RenderManifestPhoto {
  /** DPI-sized, adjustment-baked derivative (JPEG) */
  original: string;
  preview: string;
  thumb: string;
  width: number;
  height: number;
}
export interface RenderManifest {
  jobId: string;
  albumId: string;
  createdAt: string;
  photos: Record<string, RenderManifestPhoto>;
}
